var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoreCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-core-check-mark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.428,
    viewBox: "0 0 16 11.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M15.665,96.345a1.14,1.14,0,0,1,0,1.614L6.522,107.1a1.14,1.14,0,0,1-1.614,0L.335,102.531a1.142,1.142,0,0,1,1.616-1.614l3.731,3.761,8.368-8.333a1.139,1.139,0,0,1,1.614,0Z",
    transform: "translate(0 -96.01)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoreCheckMark);
export default __webpack_public_path__ + "static/media/icon-core-check-mark.68b582aceecdefedb28134df7aff0761.svg";
export { ForwardRef as ReactComponent };